import { trackClickEvent } from "../../events/clicks-tracker";
import { EnvironmentType, getEnvironmentType } from '../../utils/environment';

export function callStartTrialAPI(authData, user_id) {
    const environmentType: EnvironmentType = getEnvironmentType();

    if (!authData || !authData.token || !authData.uuid) {
        return;
    }

    fetch('/api/enem/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            action: 'start-trial',
            user_id: user_id,
            token: authData.token,
            uuid: authData.uuid,
        }),
    })
        .then((response) => {
            if (!response.ok) throw new Error('Error');
            return response.json();
        })
        .then((data) => {
            const days = data.data.days;
            if (days >= 0 && days < 365) {
                document.cookie = `enem_tm_toast=${days}; path=/`;
            }
            trackClickEvent('trial-activate');
            if ('google_tag_manager' in window) {
                window.dataLayer.push({
                    event: 'tm_trial_start',
                });
            }
            localStorage.removeItem('persist:corrector');

            if (environmentType === EnvironmentType.PRODUCTION && VWO) {
                console.log("Send VWO event");
                const date = new Date();
                window.VWO = window.VWO || [];
                VWO.event = VWO.event || function () {VWO.push(["event"].concat([].slice.call(arguments)))};
                VWO.event("startTrial", {
                    "environment": environmentType,
                    "userId": user_id,
                    "name": data.data.name,
                    "start": date.toISOString().slice(0, 19).replace("T", " "),
                    "days": parseInt(data.data.days, 10),
                });
            }

            window.location.reload();
        })
        .catch((error) => {
            console.log('Error starting trial:', error);
        });

}
